import { SET_ACTIVE_LAYER } from '../mutations'

export const state = {
  campaign: null,
  summary: null,
  creatorInsights: null,
  demographics: null,
  creatorList: [],
  contentSelectionOverview: [],
  numberOfPosts: [],
  loadingPages: false,
  bestPerformers: {},
  contentMetricsByType: {},
  contentDistribution: [],
  trendOverTime: false,
  reachByMediaType: false,
  engagementByMediaType: false,
  contentPerformance: {},
  reportPOE: {},
}

export const getters = {
  campaign: (state) => state.campaign,
  summary: (state) => state.summary,
  creatorInsights: (state) => state.creatorInsights,
  demographics: (state) => state.demographics,
  creatorList: (state) => state.creatorList,
  contentSelectionOverview: (state) => state.contentSelectionOverview,
  numberOfPosts: (state) => state.numberOfPosts,
  loadingPages: (state) => state.loadingPages,
  bestPerformers: (state) => state.bestPerformers,
  contentMetricsByType: (state) => state.contentMetricsByType,
  contentDistribution: (state) => state.contentDistribution,
  trendOverTime: (state) => state.trendOverTime,
  reachByMediaType: (state) => state.reachByMediaType,
  engagementByMediaType: (state) => state.engagementByMediaType,
  contentPerformance: (state) => state.contentPerformance,
  reportPOE: (state) => state.reportPOE,
}

export const mutations = {
  SET_CAMPAIGN(state, payload) {
    state.campaign = payload
  },
  SET_CAMPAIGN_SUMMARY(state, payload) {
    state.summary = payload
  },
  SET_CAMPAIGN_CREATOR_INS(state, payload) {
    state.creatorInsights = payload
  },
  SET_CAMPAIGN_DEMOGRAPHICS(state, payload) {
    state.demographics = payload
  },
  SET_CREATOR_LIST(state, payload) {
    state.creatorList = payload
  },
  SET_CONTENT_SELECTION_OVERVIEW(state, payload) {
    state.contentSelectionOverview = payload
  },
  SET_NUMBER_OF_POSTS(state, payload) {
    state.numberOfPosts = payload
  },
  SET_LOADING_PAGES(state, payload) {
    state.loadingPages = payload
  },
  SET_BEST_PERFORMERS(state, payload) {
    state.bestPerformers = payload
  },
  SET_CONTENT_METRICS_BY_TYPE(state, payload) {
    state.contentMetricsByType = payload
  },
  SET_CONTENT_DISTRIBUTION(state, payload) {
    state.contentDistribution = payload
  },
  SET_TREND_OVER_TIME(state, payload) {
    if (payload) {
      const categories = payload?.trend?.map((item) => item.date)
      const dataPayload = {
        categories,
        views: payload?.trend?.map((item) => item.views),
        reach: payload?.trend?.map((item) => item.reach),
        engagement: payload?.trend?.map((item) => item.engagement),
      }
      state.trendOverTime = dataPayload
    }
  },
  SET_REACH_MEDIA_TYPE(state, payload) {
    state.reachByMediaType = payload
  },
  SET_ENGAGEMENT_MEDIA_TYPE(state, payload) {
    state.engagementByMediaType = payload
  },
  SET_CONTENT_PERFORMANCE(state, payload) {
    state.contentPerformance = payload
  },
  SET_POE_REPORT(state, payload) {
    state.reportPOE = payload
  },
}
